import styled from 'styled-components';
import { PropertyCardPhotoBodyMixin } from '../../mixins/components/PropertyCardPhotoBodyMixin';
export var StyledPropertyCardPhotoBody = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledPropertyCardPhotoBody",
  componentId: "c11n-8-111-1__sc-yln73l-0"
})(["", ""], PropertyCardPhotoBodyMixin);